(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prismguard-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prismguard-mobile-purchase')) {
    customElements.define('prismguard-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(this.dataset.root);
        if (!this.root || this.observer) return;
        this.standPromo = this.querySelector('[data-pg-stand-promo]');
        this.bar = this.querySelector('[data-pg-bar]');
        this.action = this.querySelector('[data-pg-action]');
        this.images = JSON.parse(this.querySelector('[data-pg-images]').textContent || '{}');
        this.preview = this.root.querySelector('[data-pg-preview]');
        this.previewButtons = this.preview ? [...this.preview.querySelectorAll('[data-preview-variant]')] : [];
        this.colorOrder = new Map((this.dataset.colorOrder || '').trim().split('|').filter(Boolean).map((color, index) => [color, index]));
        this.swatchColors = new Map(this.previewButtons.map(button => [button.dataset.previewVariant, button.dataset.previewColor]));
        this.previousColors = [];
        this.defaultInitialized = false;
        this.bundleTouched = false;
        this.handleBundleIntent = event => {
          if (event.isTrusted && event.target.closest('.bogos-volume-discount-widget')) this.bundleTouched = true;
        };
        this.root.addEventListener('pointerdown', this.handleBundleIntent, true);
        this.root.addEventListener('keydown', this.handleBundleIntent, true);
        this.selectionRevision = 0;
        this.invalidFields = new Map();
        try {
          this.stockSnapshot = JSON.parse(this.querySelector('[data-pg-stock]')?.textContent || 'null');
          this.cartSnapshot = this.stockSnapshot?.cart;
          this.stockCheckedAt = Date.now();
        } catch { this.stockSnapshot = null; this.cartSnapshot = null; }
        this.available = new Set(JSON.parse(this.dataset.variants || '[]').map(String));
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency });
        this.root.classList.add('pg-bundle-root');
        this.schedule = () => {
          if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
        };
        this.schedulePosition = () => {
          if (!this.positionFrame) this.positionFrame = requestAnimationFrame(() => { this.positionFrame = null; this.updatePosition(this.lastState); });
        };
        this.handleClick = event => this.guardClick(event);
        this.invalidateCart = () => {
          this.cartSnapshot = null;
          this.stockCheckedAt = 0;
          this.stockFailureKey = null;
          void this.refreshStockAdvisory();
          this.schedule();
        };
        window.addEventListener('focus', this.invalidateCart);
        window.addEventListener('pageshow', this.invalidateCart);
        document.addEventListener('afterCartChanged', this.invalidateCart);
        document.addEventListener('afterUpdateQuantity', this.invalidateCart);
        this.root.addEventListener('click', this.handleClick, true);
        this.handleUnavailableKey = event => {
          if (event.key === 'Enter' || event.key === ' ') this.guardClick(event);
        };
        this.root.addEventListener('keydown', this.handleUnavailableKey, true);
        this.root.addEventListener('change', this.schedule);
        this.root.addEventListener('click', this.schedule);
        this.handlePreview = event => {
          const button = event.target.closest('[data-preview-variant]');
          const gallery = this.root.querySelector('media-gallery');
          if (!button || !this.preview.contains(button) || typeof gallery?.selectColorVariant !== 'function') return;
          gallery.selectColorVariant(button.dataset.previewVariant);
          this.syncPreview();
        };
        this.handlePreviewKeys = event => {
          const button = event.target.closest('[data-preview-variant]');
          const index = this.previewButtons.indexOf(button);
          if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? this.previewButtons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + this.previewButtons.length) % this.previewButtons.length;
          this.previewButtons[nextIndex].focus({ preventScroll: true });
          this.previewButtons[nextIndex].click();
        };
        this.preview?.addEventListener('click', this.handlePreview);
        this.preview?.addEventListener('keydown', this.handlePreviewKeys);
        window.addEventListener('scroll', this.schedulePosition, { passive: true });
        window.addEventListener('resize', this.schedule, { passive: true });
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'aria-busy', 'aria-expanded', 'data-variant-id', 'data-original-price', 'data-bogos-tier-original-price', 'data-bogos-tier-discount-price'] });
        this.handleAction = () => {
          const state = this.state();
          if (!state.ready || this.locked) return;
          if (state.button.getBoundingClientRect().bottom < 0 && state.inStock && !this.busy(state.button)) {
            state.button.click();
          } else {
            state.selected.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
            const choice = state.colors[0];
            if (choice) choice.focus({ preventScroll: true });
          }
        };
        this.action.addEventListener('click', this.handleAction);
        this.refresh();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.positionFrame);
        this.positionFrame = null;
        this.stockController?.abort();
        this.advisoryController?.abort();
        this.root?.removeEventListener('pointerdown', this.handleBundleIntent, true);
        this.root?.removeEventListener('keydown', this.handleBundleIntent, true);
        this.restoreStockButton();
        this.clearInvalidFields();
        this.frame = null;
        clearTimeout(this.unlockTimer);
        this.unlockTimer = null;
        this.locked = false;
        this.action?.removeEventListener('click', this.handleAction);
        this.preview?.removeEventListener('click', this.handlePreview);
        this.preview?.removeEventListener('keydown', this.handlePreviewKeys);
        window.removeEventListener('scroll', this.schedulePosition);
        window.removeEventListener('focus', this.invalidateCart);
        window.removeEventListener('pageshow', this.invalidateCart);
        document.removeEventListener('afterCartChanged', this.invalidateCart);
        document.removeEventListener('afterUpdateQuantity', this.invalidateCart);
        window.removeEventListener('resize', this.schedule);
        this.root?.removeEventListener('change', this.schedule);
        this.root?.removeEventListener('click', this.schedule);
        this.root?.removeEventListener('click', this.handleClick, true);
        this.root?.removeEventListener('keydown', this.handleUnavailableKey, true);
        this.root?.classList.remove('pg-bundle-ready');
      }
      setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
      selectionKey(state) {
        return JSON.stringify(state.colors.map(input => [input.dataset.variantId, input.value]));
      }
      assessStock(ids, stock, cart) {
        if (String(stock?.productId) !== this.dataset.productId || !Array.isArray(stock?.variants) || !Array.isArray(cart?.items) || !ids.length) throw new Error('Invalid stock response');
        const requested = new Map(), existing = new Map(), variants = new Map();
        stock.variants.forEach(variant => {
          const id = String(variant.id);
          if (!/^\d+$/.test(id) || variants.has(id) || typeof variant.available !== 'boolean' || typeof variant.tracked !== 'boolean' || !['deny', 'continue'].includes(variant.policy) || (variant.tracked && variant.policy === 'deny' && !Number.isSafeInteger(variant.quantity))) throw new Error('Invalid variant inventory');
          variants.set(id, variant);
        });
        cart.items.forEach(item => {
          const id = String(item.variant_id);
          if (!/^\d+$/.test(id) || !Number.isSafeInteger(item.quantity) || item.quantity < 0) throw new Error('Invalid cart quantity');
          const count = (existing.get(id) || 0) + item.quantity;
          if (!Number.isSafeInteger(count)) throw new Error('Invalid cart total');
          existing.set(id, count);
        });
        ids.forEach(id => {
          if (!variants.has(String(id))) throw new Error('Unknown variant');
          requested.set(String(id), (requested.get(String(id)) || 0) + 1);
        });
        const issues = [];
        requested.forEach((count, id) => {
          const variant = variants.get(id), inCart = existing.get(id) || 0;
          const remaining = variant.available ? Math.max(0, variant.quantity - inCart) : 0;
          if (!variant.available || (variant.tracked && variant.policy === 'deny' && count > remaining)) {
            issues.push({ id, name: variant.name, requested: count, inCart, remaining, unavailable: !variant.available });
          }
        });
        return issues;
      }
      async refreshStockAdvisory() {
        if (this.advisoryController || this.verifying || !this.isConnected) return;
        this.lastAdvisoryAttempt = Date.now();
        const controller = new AbortController();
        this.advisoryController = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        try {
          const url = new URL(window.location.href);
          url.searchParams.delete('sections');
          url.searchParams.set('section_id', 'prismguard-bundle-stock');
          url.searchParams.set('_pg_stock', String(Date.now()));
          const options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal };
          const [cartResponse, stockResponse] = await Promise.all([
            fetch(this.dataset.cartUrl, { ...options, headers: { Accept: 'application/json' } }),
            fetch(url.href, { ...options, headers: { Accept: 'text/html' } })
          ]);
          if (!cartResponse.ok || !stockResponse.ok) throw new Error('Stock request failed');
          const [cart, html] = await Promise.all([cartResponse.json(), stockResponse.text()]);
          const stock = JSON.parse(new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pg-stock]')?.textContent || 'null');
          const state = this.state();
          if (!this.isConnected || controller.signal.aborted || this.verifying) return;
          if (state.ready) this.assessStock(state.colors.map(input => input.dataset.variantId), stock, cart);
          if (String(stock?.productId) !== this.dataset.productId || !Array.isArray(stock?.variants) || !Array.isArray(cart?.items)) throw new Error('Invalid stock response');
          this.stockSnapshot = stock;
          this.cartSnapshot = { items: cart.items.map(item => ({ variant_id: item.variant_id, quantity: item.quantity })) };
          this.available = new Set(stock.variants.filter(variant => variant.available).map(variant => String(variant.id)));
          this.stockCheckedAt = Date.now();
          this.stockFailureKey = null;
        } catch {
          this.stockCheckedAt = 0;
        } finally {
          clearTimeout(timeout);
          this.advisoryController = null;
          this.schedule();
        }
      }
      defaultStockPlan(ids, stock, cart) {
        if (!this.assessStock(ids, stock, cart).length) return ids;
        const candidates = stock.variants.filter(variant => variant.available).map(variant => String(variant.id));
        candidates.sort((a, b) => (this.colorOrder.get(this.swatchColors.get(a)) ?? 999) - (this.colorOrder.get(this.swatchColors.get(b)) ?? 999));
        const uniform = candidates.find(id => !this.assessStock(ids.map(() => id), stock, cart).length);
        if (uniform) return ids.map(() => uniform);
        const result = [];
        for (const original of ids) {
          const id = [original, ...candidates.filter(candidate => candidate !== original)].find(candidate => !this.assessStock([...result, candidate], stock, cart).length);
          if (!id) return null;
          result.push(id);
        }
        return result;
      }
      initializeStockDefaults(state) {
        if (this.defaultInitialized || this.bundleTouched || !state.ready || !this.stockSnapshot || !this.cartSnapshot || Date.now() - this.stockCheckedAt > 60000) return false;
        const ids = state.colors.map(input => input.dataset.variantId);
        let plan;
        try { plan = this.defaultStockPlan(ids, this.stockSnapshot, this.cartSnapshot); } catch { return false; }
        if (!plan || plan.every((id, index) => id === ids[index])) { this.defaultInitialized = true; return false; }
        const changes = state.colors.flatMap((input, index) => {
          if (plan[index] === ids[index]) return [];
          const row = input.closest('.bogos-volume-discount-variant-item');
          const option = [...(row?.querySelectorAll('.bogos-vl-select-variant-option') || [])].find(option => option.dataset.variantId === plan[index] && option.getAttribute('aria-disabled') !== 'true');
          return [{ option, input }];
        });
        if (changes.some(change => !change.option)) return false;
        this.defaultInitialized = true;
        changes.forEach(change => {
          change.option.click();
          if (change.input.closest('.bogos-vl-select-variant-dropdown')?.classList.contains('opened')) change.input.click();
        });
        this.schedule();
        return true;
      }
      clearInvalidFields() {
        this.invalidFields?.forEach((previous, input) => {
          if (previous === null) input.removeAttribute('aria-invalid'); else input.setAttribute('aria-invalid', previous);
          const described = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== this.stockStatus?.id);
          if (described.length) input.setAttribute('aria-describedby', described.join(' ')); else input.removeAttribute('aria-describedby');
        });
        this.invalidFields?.clear();
      }
      showStockMessage(message, ids = [], retry = false, focus = false, state = this.lastState) {
        this.clearInvalidFields();
        if (!state?.button || !this.isConnected) return;
        if (!this.stockStatus?.isConnected) {
          this.stockStatus = document.createElement('div');
          this.stockStatus.className = 'pg-stock-status';
          this.stockStatus.id = `pg-stock-${this.dataset.root}`;
          this.stockStatus.setAttribute('role', 'status');
          this.stockStatus.setAttribute('aria-live', 'polite');
          this.stockStatus.setAttribute('aria-atomic', 'true');
          this.stockStatus.tabIndex = -1;
          this.stockText = document.createElement('span');
          this.stockRetry = document.createElement('button');
          this.stockRetry.type = 'button';
          this.stockRetry.textContent = this.dataset.stockRetry;
          this.stockRetry.addEventListener('click', () => this.state().button?.click());
          this.stockStatus.append(this.stockText, this.stockRetry);
        }
        const anchor = state.selected || state.button;
        if (this.stockStatus.nextElementSibling !== anchor) anchor.before(this.stockStatus);
        this.setText(this.stockText, message);
        if (this.stockStatus.hidden !== !message) this.stockStatus.hidden = !message;
        if (this.stockRetry.hidden !== !retry) this.stockRetry.hidden = !retry;
        state.colors.filter(input => ids.includes(input.dataset.variantId)).forEach(input => {
          this.invalidFields.set(input, input.getAttribute('aria-invalid'));
          input.setAttribute('aria-invalid', 'true');
          const described = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
          described.add(this.stockStatus.id);
          input.setAttribute('aria-describedby', [...described].join(' '));
        });
        if (focus) {
          const input = state.colors.find(choice => ids.includes(choice.dataset.variantId)) || state.colors[0];
          const toggle = state.selected?.querySelector('.bogos-volume-discount-item-select-button');
          if (toggle?.getAttribute('aria-expanded') === 'false' && getComputedStyle(toggle).display !== 'none') toggle.click();
          const signature = this.selectionKey(state);
          requestAnimationFrame(() => {
            if (!this.isConnected || !this.stockStatus?.isConnected || this.selectionKey(this.state()) !== signature) return;
            this.stockStatus.scrollIntoView({ behavior: 'instant', block: 'start' });
            (input?.isConnected && input.getClientRects().length ? input : this.stockStatus).focus({ preventScroll: true });
          });
        }
      }
      stockIssueMessage(issues) {
        return issues.map(issue => issue.unavailable
          ? this.dataset.stockSoldOut.replace('__COLOR__', issue.name)
          : this.dataset.stockShort.replace('__COLOR__', issue.name).replace('__REQUESTED__', issue.requested).replace('__REMAINING__', issue.remaining).replace('__CART__', issue.inCart)
        ).join('\n');
      }
      syncStockFeedback(state) {
        const key = this.selectionKey(state);
        if (key !== this.lastSelectionKey) { this.selectionRevision += 1; this.lastSelectionKey = key; this.stockFailureKey = null; }
        if (this.verifying || this.stockFailureKey === key) return;
        if (state.ready && (!this.cartSnapshot || Date.now() - this.stockCheckedAt > 60000) && Date.now() - (this.lastAdvisoryAttempt || 0) > 10000) void this.refreshStockAdvisory();
        if (!state.ready || !this.stockSnapshot || !this.cartSnapshot || Date.now() - this.stockCheckedAt > 60000) { if (key !== this.feedbackSelectionKey) this.showStockMessage('', [], false, false, state); return; }
        this.feedbackSelectionKey = key;
        try {
          const issues = this.assessStock(state.colors.map(input => input.dataset.variantId), this.stockSnapshot, this.cartSnapshot);
          this.showStockMessage(this.stockIssueMessage(issues), issues.map(issue => issue.id), false, false, state);
        } catch { this.showStockMessage('', [], false, false, state); }
      }
      restoreStockButton() {
        if (!this.stockButton) return;
        if (this.stockButton.getAttribute('aria-busy') === 'true') {
          if (this.stockButtonBusy === null) this.stockButton.removeAttribute('aria-busy'); else this.stockButton.setAttribute('aria-busy', this.stockButtonBusy);
        }
        this.stockButton.removeAttribute('data-pg-checking');
        this.stockButton = null;
      }
      guardClick(event) {
        const unavailable = event.target.closest('.bogos-vl-select-variant-option[aria-disabled="true"]');
        if (unavailable && this.root.contains(unavailable)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }
        const button = event.target.closest('.bogos-volume-discount-button-add');
        if (!button || !this.root.contains(button)) return;
        if (this.replayButton === button) {
          this.replayButton = null;
          this.unlockTimer = setTimeout(() => { this.locked = false; this.schedule(); }, 1800);
          return;
        }
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.locked || this.verifying || this.busy(button)) return;
        void this.verifyStockAndAdd(button);
      }
      async verifyStockAndAdd(button) {
        if (this.verifying || this.locked) return;
        const before = this.state();
        if (!before.ready || before.button !== button) { this.showStockMessage(this.dataset.stockError, [], true, true, before); return; }
        this.syncStockFeedback(before);
        const signature = this.selectionKey(before), revision = this.selectionRevision;
        this.locked = true;
        this.verifying = true;
        this.stockButton = button;
        this.stockButtonBusy = button.getAttribute('aria-busy');
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('data-pg-checking', '');
        this.showStockMessage(this.dataset.stockChecking, [], false, false, before);
        this.schedulePosition();
        const controller = new AbortController();
        this.stockController = controller;
        const timeout = setTimeout(() => controller.abort(), 8000);
        let replayed = false;
        try {
          const sectionURL = new URL(window.location.href);
          sectionURL.searchParams.delete('sections');
          sectionURL.searchParams.set('section_id', 'prismguard-bundle-stock');
          sectionURL.searchParams.set('_pg_stock', String(Date.now()));
          const options = { credentials: 'same-origin', cache: 'no-store', signal: controller.signal };
          const [cartResponse, stockResponse] = await Promise.all([
            fetch(this.dataset.cartUrl, { ...options, headers: { Accept: 'application/json' } }),
            fetch(sectionURL.href, { ...options, headers: { Accept: 'text/html' } })
          ]);
          if (!cartResponse.ok || !stockResponse.ok) throw new Error('Stock request failed');
          const [cart, html] = await Promise.all([cartResponse.json(), stockResponse.text()]);
          const source = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pg-stock]');
          const stock = JSON.parse(source?.textContent || 'null');
          if (!this.isConnected || controller.signal.aborted) return;
          const state = this.state();
          this.syncStockFeedback(state);
          if (!state.ready || state.button !== button || state.selected !== before.selected || this.selectionKey(state) !== signature || this.selectionRevision !== revision) {
            this.stockFailureKey = this.selectionKey(state);
            this.showStockMessage(this.dataset.stockChanged, [], false, true, state);
            return;
          }
          const issues = this.assessStock(state.colors.map(input => input.dataset.variantId), stock, cart);
          this.stockSnapshot = stock;
          this.available = new Set(stock.variants.filter(variant => variant.available).map(variant => String(variant.id)));
          this.cartSnapshot = { items: cart.items.map(item => ({ variant_id: item.variant_id, quantity: item.quantity })) };
          this.stockCheckedAt = Date.now();
          if (issues.length) {
            this.stockFailureKey = signature;
            this.showStockMessage(this.stockIssueMessage(issues), issues.map(issue => issue.id), false, true, state);
            return;
          }
          this.restoreStockButton();
          if (button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true') throw new Error('Purchase button changed');
          this.showStockMessage('', [], false, false, state);
          this.cartSnapshot = null;
          this.stockCheckedAt = 0;
          this.verifying = false;
          this.replayButton = button;
          button.click();
          replayed = this.replayButton === null;
          this.replayButton = null;
          if (!replayed) throw new Error('Purchase button detached');
        } catch {
          if (this.isConnected) {
            const state = this.state();
            this.stockFailureKey = this.selectionKey(state);
            this.showStockMessage(this.dataset.stockError, [], true, true, state);
          }
        } finally {
          clearTimeout(timeout);
          controller.abort();
          this.stockController = null;
          this.restoreStockButton();
          this.verifying = false;
          if (!replayed) this.locked = false;
          this.schedule();
        }
      }
      bundlePrices(widget) {
        return [...(widget?.querySelectorAll('.bogos-volume-discount_item-container') || [])].flatMap(tier => {
          const inputs = [...tier.querySelectorAll('.bogos-vl-select-variant-title-input')];
          if (!inputs.length) return [];
          const card = tier.querySelector('.bogos-volume-discount-item');
          const label = tier.querySelector('.bogos-volume-discount-label')?.textContent.trim() || '';
          const percentage = label.match(/(\d+(?:[.,]\d+)?)\s*%/);
          const originalRaw = card?.dataset.bogosTierOriginalPrice?.trim();
          const discountedRaw = card?.dataset.bogosTierDiscountPrice?.trim();
          const original = originalRaw ? Number(originalRaw) : NaN;
          const discounted = discountedRaw ? Number(discountedRaw) : NaN;
          if (!percentage && (label || !Number.isFinite(original) || !Number.isFinite(discounted) || Math.abs(original - discounted) > 0.005)) return [];
          const basisPoints = percentage ? Math.round(Number(percentage[1].replace(',', '.')) * 100) : 0;
          const cents = inputs.map(input => input.dataset.originalPrice?.trim() ? Math.round(Number(input.dataset.originalPrice) * 100) : NaN);
          if (basisPoints < 0 || basisPoints > 10000 || cents.some(price => !Number.isSafeInteger(price) || price < 0)) return [];
          const charged = cents.map(price => price - Math.floor(price * basisPoints / 10000));
          const total = charged.reduce((sum, price) => sum + price, 0);
          const minimum = Math.min(...charged), maximum = Math.max(...charged);
          const price = this.money.format(minimum / 100);
          return [{ tier, quantity: inputs.length, total, unit: minimum, price, display: minimum === maximum ? price : `${price}–${this.money.format(maximum / 100)}` }];
        });
      }
      syncOfferDetails(state) {
        const widget = state.widget;
        const app = widget?.closest('.shopify-app-block');
        let offer = this.root.querySelector('.pg-bundle-offer');
        if (!state.ready || this.dataset.available !== 'true' || !app) {
          if (offer) offer.hidden = true;
          if (this.standPromo) this.standPromo.hidden = true;
          if (this.paymentHome?.isConnected && this.paymentTerms?.previousElementSibling !== this.paymentHome) this.paymentHome.after(this.paymentTerms);
          return;
        }
        const tiers = state.prices.filter(tier => tier.quantity > 1);
        tiers.sort((a, b) => a.unit - b.unit || a.quantity - b.quantity);
        if (tiers.length) {
          if (!offer) {
            offer = document.createElement('p'); offer.className = 'pg-bundle-offer';
            offer.append(document.createElement('strong'), document.createElement('span'));
          }
          const previewButton = this.root.querySelector('.pg-price-preview-row .pg-price-preview');
          if (previewButton) {
            if (previewButton.previousElementSibling !== offer) previewButton.before(offer);
          } else if (app.previousElementSibling !== offer) app.before(offer);
          this.setText(offer.querySelector('strong'), this.dataset.lowest.replace('__PRICE__', tiers[0].price));
          this.setText(offer.querySelector('span'), this.dataset.lowestDetail.replace('__QUANTITY__', tiers[0].quantity));
          offer.hidden = false;
        } else if (offer) offer.hidden = true;
        if (!this.paymentTerms) {
          this.paymentTerms = this.root.querySelector('form.installment')?.parentElement;
          if (this.paymentTerms) {
            this.paymentHome = document.createElement('span'); this.paymentHome.hidden = true;
            this.paymentTerms.before(this.paymentHome);
            this.paymentTerms.classList.add('pg-payment-terms');
          }
        }
        if (this.paymentTerms && app.nextElementSibling !== this.paymentTerms) app.after(this.paymentTerms);
        if (this.standPromo) {
          const anchor = this.paymentTerms || app;
          if (anchor.nextElementSibling !== this.standPromo) anchor.after(this.standPromo);
          if (this.standPromo.hidden) this.standPromo.hidden = false;
        }
      }
      syncPreview() {
        if (!this.preview) return;
        const gallery = this.root.querySelector('media-gallery');
        if (typeof gallery?.selectColorVariant !== 'function') return;
        gallery.classList.toggle('pg-single-color-image', gallery.querySelectorAll('.product__media-item:not(.pg-color-hidden)').length < 2);
        if (this.preview.hidden) this.preview.hidden = false;
        const color = gallery.dataset.pgSelectedColor;
        this.previewButtons.forEach(button => {
          const pressed = String(button.dataset.previewColor === color);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
          if (pressed === 'true') {
            this.setText(this.preview.querySelector('[data-pg-preview-name]'), button.dataset.previewName + (button.dataset.soldOut === 'true' ? ` · ${this.dataset.soldOut}` : ''));
            if (color !== this.previewColor && window.matchMedia('(max-width: 749px)').matches) {
              const row = button.parentElement;
              const left = button.offsetLeft - row.offsetLeft;
              if (left < row.scrollLeft || left + button.offsetWidth > row.scrollLeft + row.clientWidth) row.scrollTo({ left: Math.max(0, left - row.clientWidth / 2 + button.offsetWidth / 2), behavior: 'auto' });
            }
          }
        });
        this.previewColor = color;
      }
      orderBundleColors(widget) {
        const groups = new Map();
        widget.querySelectorAll('.bogos-vl-select-variant-option').forEach(option => {
          const parent = option.parentElement;
          if (!parent) return;
          if (!groups.has(parent)) groups.set(parent, []);
          groups.get(parent).push(option);
        });
        groups.forEach((options, parent) => {
          const rank = option => this.colorOrder.get(this.swatchColors.get(option.dataset.variantId)) ?? Number.MAX_SAFE_INTEGER;
          const ordered = options.map((node, index) => ({ node, index, rank: rank(node) }))
            .sort((a, b) => a.rank - b.rank || a.index - b.index).map(item => item.node);
          if (ordered.every((node, index) => node === options[index])) return;
          const members = new Set(options);
          let next = 0;
          const children = [...parent.children].map(node => members.has(node) ? ordered[next++] : node);
          children.forEach((node, index) => {
            if (parent.children[index] !== node) parent.insertBefore(node, parent.children[index] || null);
          });
        });
      }
      applySwatches(widget) {
        const variants = this.stockSnapshot?.variants || [];
        const unavailable = variants.filter(variant => !variant.available);
        const groups = new Set([...widget.querySelectorAll('.bogos-vl-select-variant-option')].map(option => option.parentElement));
        groups.forEach(group => {
          unavailable.forEach(variant => {
            if ([...group.children].some(option => option.dataset.variantId === String(variant.id))) return;
            const option = document.createElement('div');
            option.className = 'bogos-vl-select-variant-option pg-unavailable-option';
            option.dataset.variantId = String(variant.id);
            option.dataset.pgStockPlaceholder = 'true';
            option.setAttribute('role', 'option');
            option.setAttribute('aria-selected', 'false');
            option.textContent = variant.name;
            group.append(option);
          });
          group.querySelectorAll('[data-pg-stock-placeholder]').forEach(option => {
            if (!unavailable.some(variant => String(variant.id) === option.dataset.variantId)) option.remove();
          });
        });
        this.orderBundleColors(widget);
        widget.querySelectorAll('.bogos-vl-select-variant-title-input, .bogos-vl-select-variant-option').forEach(element => {
          const color = this.swatchColors.get(element.dataset.variantId);
          const soldOut = unavailable.some(variant => String(variant.id) === element.dataset.variantId);
          if (element.classList.contains('bogos-vl-select-variant-option')) {
            element.classList.toggle('pg-unavailable-option', soldOut);
            if (soldOut) {
              if (element.getAttribute('aria-disabled') !== 'true') element.setAttribute('aria-disabled', 'true');
              if (element.tabIndex !== -1) element.tabIndex = -1;
              let badge = element.querySelector('.pg-sold-out-label');
              if (!badge) { badge = document.createElement('span'); badge.className = 'pg-sold-out-label'; element.append(badge); }
              this.setText(badge, this.dataset.soldOut);
            } else {
              if (element.getAttribute('aria-disabled') === 'true') element.removeAttribute('aria-disabled');
              element.querySelector('.pg-sold-out-label')?.remove();
            }
          }
          const field = element.classList.contains('bogos-vl-select-variant-title-input');
          const target = field ? element.closest('.bogos-vl-select-variant-dropdown') : element;
          if (!target) return;
          const className = field ? 'pg-swatch-field' : 'pg-swatch-option';
          target.classList.toggle(className, Boolean(color));
          const dotClass = field ? 'pg-field-swatch' : 'pg-option-swatch';
          let dot = target.querySelector(`:scope > .${dotClass}`);
          if (!color) { dot?.remove(); return; }
          if (!dot) {
            dot = document.createElement('span'); dot.className = dotClass;
            dot.setAttribute('aria-hidden', 'true'); target.prepend(dot);
          }
          if (dot.dataset.color !== color) dot.dataset.color = color;
        });
      }
      busy(button) { return button.disabled || button.getAttribute('aria-disabled') === 'true' || button.getAttribute('aria-busy') === 'true' || this.locked; }
      state() {
        const widget = this.root.querySelector('.bogos-volume-discount-widget');
        const button = widget?.querySelector('.bogos-volume-discount-button-add');
        const selected = widget?.querySelector('.bogos-volume-discount-tier-input:checked')?.closest('.bogos-volume-discount_item-container');
        const colors = selected ? [...selected.querySelectorAll('.bogos-vl-select-variant-title-input')] : [];
        const prices = this.bundlePrices(widget);
        const selectedPrice = prices.find(price => price.tier === selected);
        const total = selectedPrice ? this.money.format(selectedPrice.total / 100) : widget?.querySelector('.bogos-volume-discount-discount-price')?.textContent.trim();
        const ready = Boolean(widget && button && selected && total && colors.length && colors.every(input => input.dataset.variantId && input.value) && widget.getClientRects().length);
        const inStock = this.dataset.available === 'true' && colors.every(input => this.available.has(input.dataset.variantId));
        return { widget, button, selected, colors, total, prices, selectedPrice, ready, inStock };
      }
      selectionLabel(state) {
        return this.dataset.addSelection.replace('__QUANTITY__', state.colors.length).replace('__UNIT__', state.colors.length === 1 ? this.dataset.case : this.dataset.cases).replace('__TOTAL__', state.total);
      }
      syncBuyLabel(state) {
        if (!state.button) return;
        let label = state.button.querySelector('.pg-buy-label');
        if (!label) { label = document.createElement('span'); label.className = 'pg-buy-label'; state.button.append(label); }
        const show = state.ready && state.selectedPrice && state.inStock && !this.busy(state.button) && !this.verifying;
        state.button.classList.toggle('pg-labeled-buy', Boolean(show));
        if (label.hidden !== !show) label.hidden = !show;
        if (show) {
          const text = this.selectionLabel(state); this.setText(label, text);
          if (state.button.getAttribute('aria-label') !== text) state.button.setAttribute('aria-label', text);
        } else if (state.button.hasAttribute('aria-label')) state.button.removeAttribute('aria-label');
      }
      refresh() {
        if (!this.isConnected) return;
        const state = this.state();
        if (this.initializeStockDefaults(state)) return;
        this.root.classList.toggle('pg-bundle-ready', state.ready);
        this.syncOfferDetails(state);
        this.syncBuyLabel(state);
        if (state.widget) {
          const widget = state.widget;
          state.prices.forEach(price => {
            price.tier.classList.add('pg-total-tier');
            this.setText(price.tier.querySelector('.bogos-volume-discount-item-discount-price'), this.money.format(price.total / 100));
          });
          if (state.selectedPrice) this.setText(widget.querySelector('.bogos-volume-discount-discount-price'), state.total);
          this.applySwatches(widget);
          this.setText(widget.querySelector('.bogos-volume-discount-widget-title'), this.dataset.title);
          this.setText(widget.querySelector('.bogos-volume-discount-widget-description'), this.dataset.caption);
          let extras = false;
          widget.querySelectorAll('.bogos-volume-discount_item-container').forEach(tier => {
            const count = tier.querySelectorAll('.bogos-vl-select-variant-title-input').length;
            if (!count) return;
            this.setText(tier.querySelector('.bogos-volume-discount-title'), `${count} ${count === 1 ? this.dataset.case : this.dataset.cases}`);
            const shippingTag = tier.querySelector('.bogos-volume-discount-tag')?.textContent || '';
            const shippingSubtitle = tier.querySelector('.bogos-volume-discount-sub-title')?.textContent || '';
            tier.classList.toggle('pg-duplicate-shipping', /free shipping/i.test(shippingTag) && /free shipping/i.test(shippingSubtitle));
            const extra = count === 2 || count === 10;
            tier.classList.toggle('pg-extra-tier', extra);
            extras = extras || extra;
          });
          this.setText(widget.querySelector('.bogos-volume-discount-total-title span'), state.selectedPrice ? this.dataset.estimate : this.dataset.estimatedTotal);
          widget.querySelectorAll('.bogos-volume-discount-tier-price-primary > span').forEach(span => {
            const price = state.prices.find(price => price.tier.contains(span));
            this.setText(span, price ? `${price.display} ${this.dataset.each}` : this.dataset.estimatedEach);
          });
          const body = widget.querySelector('.bogos-volume-discount-widget-body');
          if (extras && body && !widget.querySelector('.pg-more-quantities')) {
            const more = document.createElement('button');
            more.type = 'button'; more.className = 'pg-more-quantities';
            more.setAttribute('aria-expanded', 'false');
            more.textContent = this.dataset.more;
            more.addEventListener('click', () => {
              const expanded = widget.classList.toggle('pg-show-all');
              more.setAttribute('aria-expanded', String(expanded));
              more.textContent = expanded ? this.dataset.less : this.dataset.more;
            });
            body.after(more);
          }
          if (state.button && !widget.querySelector('.pg-price-note')) {
            const note = document.createElement('p'); note.className = 'pg-price-note';
            note.textContent = this.dataset.note; state.button.after(note);
          }
        }
        if (state.ready && window.matchMedia('(max-width: 749px)').matches) {
          const currentColors = state.colors.map(input => input.dataset.variantId);
          const changedIndex = currentColors.length !== this.previousColors.length ? 0 : currentColors.findIndex((id, index) => id !== this.previousColors[index]);
          if (changedIndex >= 0) {
            const gallery = this.root.querySelector('media-gallery');
            if (gallery && typeof gallery.selectColorVariant === 'function') gallery.selectColorVariant(currentColors[changedIndex]);
          }
          this.previousColors = currentColors;
          state.colors.forEach(input => {
            const row = input.closest('.bogos-volume-discount-variant-item');
            const src = this.images[input.dataset.variantId];
            if (!row) return;
            if (!src) { row.querySelector('.pg-case-photo-crop')?.remove(); return; }
            let photo = row.querySelector('.pg-case-photo');
            if (!photo) {
              photo = document.createElement('img'); photo.className = 'pg-case-photo';
              photo.loading = 'lazy';
              const crop = document.createElement('span'); crop.className = 'pg-case-photo-crop';
              crop.append(photo); row.prepend(crop);
            }
            if (photo.getAttribute('src') !== src) photo.src = src;
            if (photo.alt !== input.value) photo.alt = input.value;
          });
        }
        this.syncPreview();
        this.lastState = state;
        this.syncStockFeedback(state);
        this.updatePosition(state);
      }
      updatePosition(state) {
        if (!this.isConnected || !state) return;
        let show = false;
        if (state.ready && state.inStock && window.matchMedia('(max-width: 749px)').matches) {
          const rect = state.button.getBoundingClientRect();
          const buttonVisible = rect.top < window.innerHeight - 20 && rect.bottom > 0;
          const dropdownOpen = Boolean(state.widget.querySelector('[role="combobox"][aria-expanded="true"]'));
          show = !buttonVisible && !dropdownOpen;
          this.setText(this.querySelector('[data-pg-total]'), state.total);
          this.setText(this.querySelector('[data-pg-count]'), `${state.colors.length} ${state.colors.length === 1 ? this.dataset.case : this.dataset.cases} · ${(state.selectedPrice ? this.dataset.estimate : this.dataset.estimatedTotal).toLowerCase()}`);
          this.setText(this.action, this.verifying ? this.dataset.stockChecking : this.busy(state.button) ? this.dataset.adding : rect.bottom < 0 ? this.selectionLabel(state) : this.dataset.choose);
          const disabled = this.busy(state.button);
          if (this.action.disabled !== disabled) this.action.disabled = disabled;
        }
        if (this.bar.hidden === show) this.bar.hidden = !show;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prismguard-stand-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('prismguard-stand-addon')) {
    const standSelector = 'button.bogos-gift-item-add-btn[data-offer="215139"][data-product="10295119446239"]';
    const quietStandPopup = () => {
      const popup = document.querySelector('#freegifts-main-popup-container.sca-is-visible-fg');
      if (!popup || !popup.querySelector(standSelector)) return;
      if (popup.querySelector('button.bogos-gift-item-add-btn:not([data-offer="215139"])')) return;
      popup.querySelector('.bogos-slider-close-btn')?.click();
    };
    new MutationObserver(quietStandPopup).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    quietStandPopup();
    customElements.define('prismguard-stand-addon', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const select = this.querySelector('select');
        const button = this.querySelector('button[type="submit"]');
        button.disabled = false;
        select.addEventListener('change', () => {
          for (const image of this.querySelectorAll('.pg-stand-addon__intro img, .pg-stand-addon__thumbnail')) {
          if (select.selectedOptions[0].dataset.image) {
            image.removeAttribute('srcset');
            image.src = select.selectedOptions[0].dataset.image;
            image.alt = select.selectedOptions[0].textContent.trim() + ' PSA display stand';
          }
          }
        });
        this.querySelector('form').addEventListener('submit', async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (this.busy) return;
          this.busy = true;
          const original = button.textContent;
          const error = this.querySelector('[role="alert"]');
          button.disabled = true;
          button.textContent = this.dataset.adding;
          error.hidden = true;
          try {
            const nativeButton = document.querySelector(standSelector + '[data-variant="' + select.value + '"]');
            if (!nativeButton || nativeButton.disabled) throw new Error(this.dataset.loadingOffer);
            nativeButton.click();
            let added = false;
            for (let attempt = 0; attempt < 20; attempt++) {
              await new Promise(resolve => setTimeout(resolve, 500));
              const response = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
              if (!response.ok) continue;
              const cart = await response.json();
              if (cart.items.some(item => String(item.variant_id) === select.value && item.line_level_discount_allocations?.length)) {
                added = true;
                break;
              }
            }
            if (!added) throw new Error(this.dataset.error);
            const drawer = this.closest('cart-drawer');
            if (drawer) {
              const response = await fetch(this.dataset.cartUrl + '?sections=cart-drawer,cart-icon-bubble', {cache:'no-store'});
              const sections = await response.json();
              if (!response.ok || !sections['cart-drawer'] || !sections['cart-icon-bubble']) throw new Error(this.dataset.error);
              drawer.renderContents({sections});
            } else {
              window.location.assign(this.dataset.cartUrl);
            }
          } catch (failure) {
            error.textContent = failure.message || this.dataset.error;
            error.hidden = false;
          } finally {
            this.busy = false;
            button.disabled = false;
            button.textContent = original;
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
